'use client';

import { createContext, useContext, type ReactNode } from 'react';

// Routes with translated slugs supply their actual published counterparts.
const LocalizedPageLinks = createContext<Record<string, string> | null>(null);

export function LocalizedPageLinksProvider({
  links,
  children,
}: {
  links: Record<string, string> | null;
  children: ReactNode;
}) {
  return (
    <LocalizedPageLinks.Provider value={links}>
      {children}
    </LocalizedPageLinks.Provider>
  );
}

export function useLocalizedPageLinks() {
  return useContext(LocalizedPageLinks);
}
